import { ColorPalette, ErrorState } from '@shared/components';

export default function AccessDeniedPage() {
  return (
    <ErrorState
      title='ไม่มีสิทธิ์การเข้าถึง'
      description='กรุณาติดต่อผู้ดูแลระบบ เพื่อขอสิทธิ์การเข้าถึง'
      slotProps={{
        icon: {
          color: ColorPalette.PRIMARY,
        },
      }}
      fullscreen
    />
  );
}
